import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Show splash for 2 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onComplete();
      }, 500); // Wait for fade out animation
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-black flex items-center justify-center transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="animate-pulse">
        <img
          src="https://customer-assets.emergentagent.com/job_barber-cape-coral/artifacts/krs782np_836.png"
          alt="Sauce Sity Logo"
          className="w-64 h-64 md:w-80 md:h-80 object-contain"
        />
      </div>
    </div>
  );
};

export default SplashScreen;
